import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import Container from '@mui/material/Container';
import { checkToken, getToken, getPermission } from '../auth/ApiAuth';
import Navbar from '../components/Navbar'
import Footer from "../components/Footer";
import Box from '@mui/material/Box';
import UserListStats from '../components/UserListStats'
import DialogEditDriver from '../components/DialogEditDriver'
import ConfirmDialog from '../components/DialogConfirmDelete';
import AlertCard from '../components/AlertCard'

import {Typography} from '@mui/material';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import { setDrivers, updateDriver, setEditedDriver, editDriver, createDriver, resetEditedDriver, deleteDriver } from '../redux/actions/driver'
import { setCounterLoading } from '../redux/actions/lessons'
import { getStudentIds, getStudentsByIds } from '../api/users'


const ArchiveStudents = ({
  editedDriver,
  editDriver
}) => {
  const dispatch = useDispatch()
  let history = useHistory();
  if (checkToken(getToken()) || getPermission('student')) {
    history.push("/Login");
  }

  const [driverDialogOpen, setDriverDialogOpen]   = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deletedDriverId, setDeletedDriverId]     = useState('');
  const [isAlertCardOpen, setIsAlertCardOpen]     = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [allIds, setAllIds] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const studentCounters = useSelector(state => state.lesson.typeCounter.counter)

  const AlertCardConst = (
    <AlertCard
      type="error"
      value="Nie udało się zaktualizować danych kursanta. Spróbuj ponownie."
    />
  )

  useEffect(() => {
    dispatch(setCounterLoading(false))
    ;(async () => {
      try {
        const idsResp = await getStudentIds({ is_active: false });
        const ids = Array.isArray(idsResp?.ids) ? idsResp.ids : [];
        setAllIds(ids);
        setRowCount(ids.length);
        await fetchPage(0, rowsPerPage, ids);
      } catch (e) {
        console.log(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  async function fetchPage(newPage, newRowsPerPage, ids = allIds) {
    const start = newPage * newRowsPerPage;
    const end = start + newRowsPerPage;
    const slice = ids.slice(start, end);
    const resp = await getStudentsByIds(slice);
    const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : []);
    dispatch(setDrivers(list));
  }

  const handleServerPageChange = async (newPage) => {
    setPage(newPage);
    await fetchPage(newPage, rowsPerPage);
  };

  const handleServerRowsPerPageChange = async (value) => {
    setRowsPerPage(value);
    setPage(0);
    await fetchPage(0, value);
  };

  const reloadIdsAndPage = async (desiredPage = page, desiredRowsPerPage = rowsPerPage) => {
    try {
      const idsResp = await getStudentIds({ is_active: false });
      const ids = Array.isArray(idsResp?.ids) ? idsResp.ids : [];
      setAllIds(ids);
      const newCount = ids.length;
      setRowCount(newCount);
      const maxPage = desiredRowsPerPage > 0 ? Math.max(0, Math.ceil(newCount / desiredRowsPerPage) - 1) : 0;
      const safePage = Math.min(desiredPage, maxPage);
      setPage(safePage);
      await fetchPage(safePage, desiredRowsPerPage, ids);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmitDriver = async (RegData, driverData) => {
    if (RegData.password) {
      if (RegData.password.length >= 8) {
        if (editedDriver.isEdited()) {
          await dispatch(updateDriver(RegData, editedDriver.pk));
        } else {
          await dispatch(createDriver(RegData, driverData));
        }
      } else {
        setIsAlertCardOpen(true);
        window.setTimeout(setIsAlertCardOpen, 2000, false);
      }
    }
    else {
      if (editedDriver.isEdited()) {
        await dispatch(updateDriver(RegData, editedDriver.pk));
      } else {
        await dispatch(createDriver(RegData, driverData));
      }
    }

    setDriverDialogOpen(false);
    await reloadIdsAndPage(0, rowsPerPage);
  };

  const handleAddDriverClick = () => {
    setDriverDialogOpen(true);
  };
  const handleDriverEditdDialogClose = () => {
    dispatch(resetEditedDriver())
    setDriverDialogOpen(false);
  };
  const handleEditDriverClick = (driver) => {
    dispatch(setEditedDriver(driver))
    setDriverDialogOpen(true);
  };
  const handleDeleteDriverClick = (driver) => {
    setDeletedDriverId(driver.pk)
    setConfirmDialogOpen(true)
  }
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false)
  }
  const handleConfirmDeleteDriver = async () => {
    await dispatch(deleteDriver(deletedDriverId))
    setConfirmDialogOpen(false)
    setDeletedDriverId('');
    await reloadIdsAndPage(page, rowsPerPage);
  }
  const confirmContentText = `Usunięcie konta kursanta jest operacją nieodwracalną.
  Czy na pewno chcesz usunąć konto tego użytkownika?`;

  //const driverAction = dispatch(editDriver())
  //const editedDriver = useSelector(state => state.driver.editedDriver)

  const drivers = useSelector(state => state.driver)
  return (
    <Box>
      <Container component="main" maxWidth="lg">
        <Navbar />
        {isAlertCardOpen ? AlertCardConst : ''}
       
        <Typography
            style={{paddingTop:'150px'}}
            variant="h5"
        >
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
            }}>
                <HistoryToggleOffIcon 
                    fontSize='large'
                    color='warning'
                />
                <span> &nbsp; Archiwum nieaktywnych kursantów</span>
            </div> 
           
        </Typography>
        <DialogEditDriver
          editedDriver={editedDriver}
          open={driverDialogOpen}
          onChange={editDriver}
          onClose={handleDriverEditdDialogClose}
          onSubmit={handleSubmitDriver}
        />
        <ConfirmDialog
          open={confirmDialogOpen}
          onConfirm={handleConfirmDeleteDriver}
          onClose={handleConfirmDialogClose}
          title="Usuwanie konta kursanta"
          contentText={confirmContentText}
        />
        <UserListStats
          users={drivers.driversList}
          counters={studentCounters}
          serverPagination
          page={page}
          rowsPerPage={rowsPerPage}
          rowCount={rowCount}
          onServerPageChange={handleServerPageChange}
          onServerRowsPerPageChange={handleServerRowsPerPageChange}
          isAddable={false}
          onAddUser={handleAddDriverClick}
          onEditUser={handleEditDriverClick}
          onDeleteUser={handleDeleteDriverClick}
          isArchive={true}
          isActiveField
          addableUsers
          editableUsers
          overallLessonsField
        />
      </Container>
      <Footer/>
    </Box>
  );
}
const mapStateToProps = (state) => ({
  editedDriver: state.driver.editedDriver
})

const mapDispatchToProps = (dispatch) => ({
  editDriver: (editDriverData) => dispatch(editDriver(editDriverData))
});


export default connect(mapStateToProps, mapDispatchToProps)(ArchiveStudents);
